import { type NaviItem } from '@interface/ICommon';

export const NAVI_ITEM_LIST: NaviItem[] = [
    { label: 'ABOUT', href: '#about', offsetY: 0 },
    { label: 'CONTACT', href: '#contact', offsetY: 0 },
];

export const SECTION_CONFIG = {
    main: { headerBgColor: 'rgba(0, 0, 0, 0.15)' },
    about: { headerBgColor: 'rgba(0, 0, 0, 0.7)' },
    contact: { headerBgColor: 'rgba(0, 0, 0, 0.7)' },
};

export const FAMILYSITE_LIST = [
    { label: 'NC', href: 'https://kr.ncsoft.com/', target: '_blank' },
    { label: 'NC WEST', href: 'https://us.ncsoft.com/en-us', target: '_blank' },
    { label: 'NC JAPAN', href: 'https://www.ncjapan.co.jp/', target: '_blank' },
    { label: 'NC TAIWAN', href: 'https://www.nctaiwan.com/', target: '_blank' },
    { label: 'NC ITS', href: 'https://www.ncits.co.kr/', target: '_blank' },
    { label: 'NC IDS', href: 'https://nc-ids.co.kr/', target: '_blank' },
    { label: 'NC QA', href: 'https://nc-qa.com/', target: '_blank' },
    { label: 'NC AI', href: 'https://nc-ai.com/', target: '_blank' },
    { label: 'NC SERVICE', href: 'https://ncsoftservice.com/', target: '_blank' },
    { label: 'NC VVS', href: 'https://www.ncvvs.vn/', target: '_blank' },
    { label: 'FIRSTSPARK GAMES', href: 'https://firstsparkgames.com', target: '_blank' },
    { label: 'LUDIUS GAMES', href: 'https://ludiusgames.com/', target: '_blank' },
];

export const MACOS_UNSUPPORTED_MESSAGE =
    "This game doesn't support MacOS, but you can register on mobile (iOS/Android) or download it for Windows PC.";

export type GameId = 'l2m' | 'lw';

export const GAME_DOWNLOAD_URLS: Record<GameId, { vn?: string; sea: string }> = {
    l2m: {
        vn: 'https://l2mvn.onelink.me/Re42/homepage',
        sea: 'https://l2msa.onelink.me/uweK/homepage',
    },
    lw: {
        sea: 'https://lineagewsa.onelink.me/q8Gt/tzdmexdw',
    },
};
